import { SET_MODAL_FORM_OPEN_STATUS } from '../actionTypes';
import { actions } from '../reducer';

export default (value) => actions[SET_MODAL_FORM_OPEN_STATUS](value);
